export default {
      id: "voxkit-usage",
      viewBox: "0 0 263 75",
      url: "assets/" + "sprite.svg#voxkit-usage",
      toString: function () {
        return this.url;
      }
    }